import { Button, ButtonGroup, ButtonVariant, Icon, Intent, Size } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { DIALOG_SIZE, HTML, ID, VKVideoItem } from "src/libs/interfaces/layouts"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ScalableDialog } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import { LANDING_TYPE_CONTENT } from "../../data/interfaces"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import CardEditor from "./CardEditor"
import LandingCompositeDefault from "./LandingCompositeDefault"

/* Protopia Ecosystem component */
export interface ICardScalarProps extends ICompositeWidgetProps {
   
}
const VKVideoScalar = (props: ICardScalarProps): JSX.Element => {  
    return <>
        <Scalar  
            value={ props.value }
            editable={props.editable }
            field={props.field}
            notClear
            rowClassName="width-auto"
            vertical={ VerticalType.VERTICAL }
            enabledForm={ <VKVideoEnabled {...props} /> }  
            desabledForm={ <VKVideoDisable {...props} /> }  
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}  
            onChange={props.onChange}
        />
    </>
}
export default VKVideoScalar

const VKVideoDisable = (props: ICompositeWidgetProps): JSX.Element => { 
    const [value, setValue] = useState<VKVideoItem[]>( props.value || [] ) 
    useEffect(() => {
        setValue( props.value || [] )
    }, [props.value])
    return <div className="d-flex flex-wrap">{ value.length } {__( "items" )}</div>
}


const VKVideoEnabled = (props: ICompositeWidgetProps): JSX.Element => {
    const [value, setValue] = useState<VKVideoItem[]>( props.value || [] ) 
    const [isOpen, setIsOpen] = useState<boolean>( false )
    const [current, setCurrent] = useState<VKVideoItem | undefined>( undefined )
    const [n, setN] = useState<number>(0)
    useEffect(() => {
        setValue( props.value || [] )
    }, [props.value])
    
    const onPrev = (id: ID) => {
        const cards = [...value]
        const index = cards.findIndex(card => card.src === id)
        const card = cards[index]
        cards.splice(index, 1)
        cards.splice(index - 1, 0, card) 
        if( !!props.onChange ) {
            props.onChange(cards, props.field, "")
        } 
    }
    const onNext = (id: ID) => {
        const cards = [...value]
        const index = cards.findIndex(card => card.src === id)
        const card = cards[index]
        cards.splice(index, 1)
        cards.splice(index + 1, 0, card)  
        setValue(cards)
        if( !!props.onChange ) {
            props.onChange(cards, props.field, "")
        } 

    }
    const duplicate = (id: ID) => {
        const cards = [...value]
        const index = cards.findIndex(card => card.src === id)
        const card = {...cards[index], src: "", label: "VK Video" }
        cards.splice(index, 0, card)    
        setValue(cards)
        if( !!props.onChange ) {
            props.onChange(cards, props.field, "")
        } 
    }
    const onRemove = (id: ID) => { 
        const cards = value.filter(card => card.src !== id)
        setValue(cards)
        if( !!props.onChange ) {
            props.onChange(cards, props.field, "")
        }
    }

    const onChange = ( _value: VKVideoItem[]) => { 
       
    } 
    const onAdd = () => {
        const newVideo: VKVideoItem = {src: "", label: "VK Video", image: "", content: ""}
        setValue([ ...value, newVideo ])
        if( !!props.onChange ) {
            props.onChange([ ...value, newVideo ], props.field, "")
        }
    }  
    const onChangeCurrent = (i: number, _value: VKVideoItem) => {
        const cards = [...value]
        cards.splice(i,1, _value)
        setValue(cards)
        if( !!props.onChange ) {
            props.onChange(cards, props.field, "")
        }
        setIsOpen(false)
    }
    const getTitle = (item: VKVideoItem): HTML => {
        if(item.label) {
            return item.label
        }
        return __("VK video") 
    }
    const onChoose = (item: VKVideoItem, i: number) => {
        setCurrent(item)
        setIsOpen(true)
        setN(i)
    }
    return <div className="w-100 mb-3 px-3"> 
        <div className=" overflow-y-auto d-flex flex-wrap p-2" style={{maxHeight: 600}}>
            { 
                value.map((item: VKVideoItem, i: number) => { 
                    return  <div key={ item.src } className="position-relative">
                        <Button className=' btn-stretch p-1 m-1 position-relative' variant={ButtonVariant.OUTLINED} onClick={ () => onChoose(item, i) } >
                            <div className="square2 flex-centered small text-wrap text-center"  dangerouslySetInnerHTML={{ __html: getTitle( item ) }} />
                        </Button>
                        <CardEditor 
                            i={i} 
                            item={item} 
                            type={LANDING_TYPE_CONTENT.VK_VIDEO} 
                            cards={ props.origin?.items || []} 
                            sectionId={props.sectionId}
                            cardsMeatId={props.origin.id}
                            duplicate={() => duplicate(item.src)}
                            doDelete={() => onRemove(item.src)}
                            onPrev={() => onPrev(item.src)}
                            onNext={() => onNext(item.src)} 
                            
                        />
                    </div>
                })
            }
            <AddCardBtn onAdd={onAdd} />
            <ScalableDialog
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                dialogSize={ DIALOG_SIZE.NORMAL }
            >
                <VKVideoDialogCurrent
                    current={current}
                    n={n}
                    origin={props.origin}
                    onClose={() => setIsOpen(false)}
                    onChangeCurrent={ onChangeCurrent }
                />
            </ScalableDialog>
        </div> 
    </div>
}


export const VKVideoDialogCurrent = ({onChangeCurrent, current, n, origin, onClose}: any) => {
    const [value, setValue] = useState<VKVideoItem>( current )  
    const [isUpdated, setIsUpdated] = useState<boolean>(false)
    useEffect(() => {
        setValue( current )
    }, [ current ])
    
    const onUpdate = ( _value: any, field: string) => {
        setValue({...value, [field]: _value})
        setIsUpdated(true)
    }
    const onFull = () => {
        onChangeCurrent(n , value)
        setIsUpdated( false ) 
    }
    return <>
        <div className="p-3 max-height overflow-y-auto">
            <LandingCompositeDefault
                value={current} 
                origin={origin}
                isAlwaysOpen
                isDefaultOpen
                isNotCard
                type={ LANDING_TYPE_CONTENT.VK_VIDEO }
                onChange={onUpdate}  
                dataSection="section"
                dataName={ LANDING_TYPE_CONTENT.VK_VIDEO }
            />
        </div>
        <ButtonGroup className="w-100">
            <Button size={Size.LARGE} fill intent={Intent.SUCCESS} disabled={!isUpdated} onClick={ onFull }>
                {__("Update")}
            </Button>
            <Button size={Size.LARGE} fill onClick={ onClose }>
                {__("Cancel")}
            </Button>
        </ButtonGroup> 
    </>
}

export const AddCardBtn = ({onAdd}: any) => {
    return <Button className=' btn-stretch m-1' variant={ButtonVariant.MINIMAL} onClick={onAdd}>
        <div className="square2 flex-centered">
           <Icon icon="plus" />
        </div>
    </Button>
}

export interface ISingleCardScalarProps {
    id: ID
    origin: any
    item: any
    schema: any 
    i: number
    sectionId: ID
    onChange: ( id: ID, value: any ) => void
    onPrev: ( id: ID ) => void
    onNext: ( id: ID ) => void
    onRemove: ( id: ID ) => void
    duplicate: ( id: ID ) => void
}
export const SingleCardScalar = (props: ISingleCardScalarProps): JSX.Element => {  
    const getTitle = (): HTML => {
        if(props.item.label) {
            return props.item.label
        }
        return __("VK video") 
    }
    return <Button className=' btn-stretch p-1 m-1 position-relative' variant={ButtonVariant.OUTLINED}>
            <div className="square2 flex-centered small text-wrap text-center" dangerouslySetInnerHTML={{__html: getTitle()}}>
               
            </div>
            {/*  */}
        </Button>
} 